import { fetchEntrances, fetchEntrance, removeEntrance } from '../repositories/entrance.repository'

const state = {
    entrances: [],
    entrance: null
}

const actions = {
    fetchEntrances ({ commit }, fields = null) {
        return new Promise(resolve => fetchEntrances(fields)
            .then(res => {
                commit('setEntrances', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    fetchEntrance ({ commit }, id) {
        return new Promise(resolve => fetchEntrance(id)
            .then(res => {
                commit('setEntrance', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    /* eslint-disable no-unused-vars */
    removeEntrance ({ dispatch }, id) {
        return removeEntrance(id)
    }
}

const mutations = {
    setEntrances (state, entrances) {
        state.entrances = entrances
    },
    setEntrance (state, entrance) {
        state.entrance = entrance
    }
}

const getters = {
    getBuildingEntrances (state) {
        return id => {
            const buildingEntrances = state.entrances.filter(entrance => entrance.buildingId === id)
            return buildingEntrances.length ? buildingEntrances : state.entrances
        }
    }
}

export default {
    state,
    actions,
    getters,
    mutations
}